/**
 * Handles removing a file from the upload list by index.
 * Revokes the object URL to avoid memory leaks.
 * Adjusts selectedIndex if the removed file was selected or was the last in the list.
 */
export default class OnFileRemovedHandler {

    /**
     * @param {object} state - shared upload state from UploadAttachmentHandler
     */
    constructor(state) {
        this._state = state;
    }

    /**
     * Removes file at index, revokes previewUrl, adjusts selectedIndex.
     * @param {{ index: number }} data
     */
    handle({ index }) {
        const entry = this._state.files[index];
        if (!entry) return;

        // Revoke object URL before removing — prevents memory leak
        if (entry.previewUrl) URL.revokeObjectURL(entry.previewUrl);

        this._state.files = this._state.files.filter((_, i) => i !== index);

        // Keep selectedIndex in bounds after removal
        if (this._state.selectedIndex >= this._state.files.length) {
            this._state.selectedIndex = Math.max(0, this._state.files.length - 1);
        }
    }
}
